/**
 * /google-login
 *
 * This path is registered as an authorized redirect URI in Google Cloud Console.
 * For the implicit/popup flow used by @react-oauth/google, Google handles
 * the token exchange internally and this page is not actively used as a redirect target.
 *
 * However, having the route registered ensures the URI passes Google's validation
 * and is available if the flow ever switches to authorization code flow.
 *
 * Any direct navigation here is redirected to the login page.
 */
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function GoogleLoginRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/login', { replace: true });
  }, [navigate]);

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
      <p style={{ color: '#6b7280', fontSize: 14 }}>Completing sign-in…</p>
    </div>
  );
}
